import { useState } from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { LoadingButton } from "@mui/lab";

interface TermsAcceptanceDialogProps {
  open: boolean;
  onAccept: () => Promise<void>;
}

export const TermsAcceptanceDialog = ({
  open,
  onAccept,
}: TermsAcceptanceDialogProps) => {
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try {
      await onAccept();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent sx={{ p: 4 }}>
        <Stack spacing={3}>
          <Typography variant="h4">Terms of Service</Typography>
          <Typography variant="body2" color="text.primary">
            Please review and accept the{" "}
              <Link
                component="a"
                href="https://s3.us-east-2.amazonaws.com/assets.getsnug.com/files/User+Terms+of+Service.pdf"
                target="_blank"
              >Terms of Service</Link>{" "}to continue using
            the application.
          </Typography>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              ml: -1,
            }}
          >
            <Checkbox
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
            />
            <Typography color="text.secondary" variant="body2">
              I have read, understand, and agree to be bound by the Terms of Service
            </Typography>
          </Box>
          <LoadingButton
            fullWidth
            variant="contained"
            disabled={!accepted}
            loading={loading}
            onClick={handleAccept}
          >
            Continue
          </LoadingButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
